import { render, staticRenderFns } from "./AProduct.vue?vue&type=template&id=58600908"
import script from "./AProduct.vue?vue&type=script&lang=js"
export * from "./AProduct.vue?vue&type=script&lang=js"
import style0 from "./AProduct.vue?vue&type=style&index=0&id=58600908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports